export default __webpack_public_path__ + "static/media/the-hermit-pressed@2x.aa78c6e6.png";